import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CIcon from '@coreui/icons-react';
import { Organization } from '../../models/organization';
import {
  selectOrgHierarchyActiveNode,
} from '../../../store/selectors/orgHierarchy.selectors';
import OrgHierarchyItem from './OrgHierarchyItem';

interface OrgHierarchyChildrenProps {
  orgs: Organization[];
  root?: boolean;
  parent: Organization;
  onOpenCreateOrgModal: (parent: Organization) => void;
  creatable: boolean;
  filterQuery: string;
}

const OrgHierarchyChildren = (props: OrgHierarchyChildrenProps) => {
  const { orgs, root, parent, onOpenCreateOrgModal, creatable, filterQuery } = props;
  const activeNode = useSelector(selectOrgHierarchyActiveNode);
  const [currentActiveNode, setCurrentActiveNode] = useState(null);

  useEffect(() => {
    if (orgs?.length > 0 && activeNode) {
      const node = orgs.find((child) => [...activeNode?.hierarchy, activeNode?._id].indexOf(child?._id) > -1);
      setCurrentActiveNode(node);
    }
  }, [activeNode, orgs]);

  return (
    <>
      <div className="glympse-orgHierarchy-children">
        {
          orgs?.filter((org) => {
            if (
              ((activeNode?.children?.length === 0 || !activeNode?.children) && org?.parent_id === activeNode?.parent_id) 
              || org?.parent_id === activeNode?._id
            ) {
              return org?.name?.toLowerCase()?.indexOf(filterQuery?.toLowerCase()) > -1;  
            }
            return true;
          })?.map((child) => {
            return <OrgHierarchyItem org={child} isActive={currentActiveNode?._id === child?._id} key={child?._id} filterQuery={filterQuery} />
          })
        }
        {
          (!root && creatable) ? (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
            <div className="glympse-orgHierarchy-node-item bg-white" onClick={() => onOpenCreateOrgModal(parent)} >
              <div className="glympse-orgHierarchy-create-org">
                <CIcon size="sm" name="cil-plus" />
                <span className="glympse-orgHierarchy-create-org-title">Create a new org</span>
              </div>
            </div>
          ): null
        }
      </div>
      {
        currentActiveNode?.children && (
          <OrgHierarchyChildren
            orgs={currentActiveNode?.children}
            parent={currentActiveNode}
            onOpenCreateOrgModal={onOpenCreateOrgModal}
            creatable={creatable}
            filterQuery={filterQuery}
          />
        )
      }
    </>
  )

};

OrgHierarchyChildren.defaultProps = {
  root: false
};

export default OrgHierarchyChildren;
